/*
 * Copyright 2017 Red Hat, Inc. and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/// <reference path="keycloak.d.ts"/>

import {Injectable} from '@angular/core';
import * as configlist from '../../assets/config/config';

const Keycloak = require('./keycloak'); // load keycloak.js locally
type KeycloakClient = KeycloakModule.KeycloakClient;

@Injectable({
    providedIn: 'root'
})
export class KeycloakService {
    static keycloakAuth: KeycloakClient = Keycloak(configlist.keycloakjson);

    static init(options?: any): Promise<any> {
        return new Promise((resolve, reject) => {
            KeycloakService.keycloakAuth.init(options)
                .success(() => {
                    resolve();
                })
                .error((errorData: any) => {
                    console.log('error in keyclock service ts', errorData)
                    reject(errorData);
                });
        });
    }

    authenticated(): boolean {
        return KeycloakService.keycloakAuth.authenticated;
    }

    login() {
        KeycloakService.keycloakAuth.login();
    }

    logout() {
        KeycloakService.keycloakAuth.logout();
    }

    account() {
        KeycloakService.keycloakAuth.accountManagement();
    }

    loadUserProfile() {
        if (!window.opener) { return; }
        if (sessionStorage.getItem('ssoProfilePosted') === 'true') { return; }
        sessionStorage.setItem('ssoProfilePosted', 'true');
        KeycloakService.keycloakAuth.loadUserProfile().success(function(data) {
            data.kcsessionid = sessionStorage.getItem('kcsessionid');
            window.opener.postMessage(data, window.location.href);
            window.close();
        });
    }
    loadUserInfo() {
        if (!window.opener) { return; }
        KeycloakService.keycloakAuth.loadUserInfo().success(function(data) {
            window.opener.postMessage(data, window.location.href);
            window.close();
        });
    }

    getToken(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if (KeycloakService.keycloakAuth.token) {
                KeycloakService.keycloakAuth
                    .updateToken(5)
                    .success(() => {
                        resolve(<string>KeycloakService.keycloakAuth.token);
                    })
                    .error(() => {
                        reject('Failed to refresh token');
                    });
            } else {
                reject('Not loggen in');
            }
        });
    }
}
